export default "__VITE_ASSET__CPu0bH2m__"